module.exports = __webpack_public_path__ + "components/flag/static/square/ci-a01d68d17b86f5f0d94c5a762200e0d3.svg";